<template lang="html">
  <div class="notice_content">
    <div class="list_div">
        <Table
          :columns="columns"
          :data="list"
          v-if="total > 0">
        </Table>
        <div class="page clear" v-if="total > 10">
            <Page :total="total" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator/>
        </div>
    </div>
    <Nothing v-if="total == 0 && !spinShow">
      <p>暂无相关公告</p>
    </Nothing>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { entityDetail } from '../../../service'
import filter from 'js/filter'
import Nothing from '@/components/Nothing2'
export default {
  data() {
    return {
      spinShow: true,
      list: [],
      total: 0,
      params: {
        uid: this.$route.params.uid,
        type: 'notice',
        page: 1
      },
      columns: [
        {title: '序号',type: 'index',width: 80,align: 'center'},
        {title: '公告名称',minWidth: 120,key: 'title',render: (h, params) => {
            return h('div',{class: {vertical: true}},filter.empty(params.row.title))
          }
        },
        {title: '公告类型',width: 200,render: (h, params) => {
            return h('span',filter.empty(params.row.notice_type))
          }
        },
        {title: '公告时间',width: 120,render: (h, params) => {
            return h('span',filter.timeTrans(params.row.pub_date))
          }
        },
        {title: '下载公告',width: 100,render: (h, params) => {
            return h('a',{
              attrs:{
                href: params.row.pdf_url,
                target: '_blank'
              },
              class: {upload_ico: true},
              on: {click:() => {_czc.push(['_trackEvent', '公司详情', '公司公告_查看详情点击'])}},
            }, [
              h('i', {class: {iconfont: true}, domProps: {
                innerHTML: '&#xe62e;'
              }}),
              h('span','查看')
            ])
          }
        }
      ]
    }
  },
  components: {
    Nothing
  },
  methods: {
    async getDetail() {
      let res = await entityDetail(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'list', res.notice)
        if(this.list.length > 0) this.$emit('callbackData', 'NoticeInfo')
        this.total = res.count
        this.spinShow = false;
      } else {
        this.$Message.error(res.msg)
      }
      this.$nextTick(() => {this.spinShow = false})
    },
    handlePage(page) {
      this.params.page = page
      this.getDetail()
    }
  },
  created() {
    this.getDetail()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.notice_content
  padding: 32px 50px
.ivu-table-wrapper >>> a.upload_ico
  color: rgba(250, 122, 80, 1)
  .iconfont
    display: inline-table
    vertical-align: top
    font-size: 14px
    margin-right: 4px
</style>
